<template>
  <div class="flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>
        <vs-divider position="center"><h5>Generate payment link</h5></vs-divider>

        <div class="subscription">
          <span>Please provide booking id to generate link.</span>
          <vs-input
            type="number"
            label="Booking Id"
            placeholder="Booking Id"
            v-model="booking_id"
            class="w-full mt-4 mb-2"
          />

          <vs-button class="w-full" @click="go_generate()" :disabled="!booking_id">Generate</vs-button>
          <div class="mt-6" v-if="payment_link">
            Generated Link is:
            <a v-bind:href="payment_link">{{ payment_link }}</a>
          <vs-divider position="center"><h5>Booking Details</h5></vs-divider>

          <span class="mt-4 flex items-center"><h6>Pickup : </h6> &nbsp; {{source}}</span>
          <span class="flex items-center"><h6>Destination : </h6> &nbsp; {{destination}}</span>
          <span class="flex items-center"><h6>Booked at time : </h6> &nbsp; {{date_time}}</span>
          <span class="flex items-center"><h6>Pickup due time : </h6> &nbsp; {{pickup_due_time}}</span>
          <span class="flex items-center"><h6>Price : </h6> &nbsp; £ {{price}}</span>
          </div>
        </div>
        <div class="options-alignment"  v-if="payment_link">
              <vs-button color="success"  icon-pack="feather" icon="icon-smartphone" icon-after @click="smsPrompt = true">Send SMS</vs-button>
              <vs-button color="success"  icon-pack="feather" icon="icon-mail" icon-after @click="emailPrompt = true" >Send Email</vs-button>
        </div>
      </vx-card>

     <vs-prompt
     title="SMS to customer"
     accept-text="Send"
     @accept="send_sms"
      :active.sync="smsPrompt">
       <div class="con-exemple-prompt">
          Enter the phone number
         <vs-input class="w-full mt-2" placeholder="+447*******" v-model="customer_telephone"/>
       </div>
     </vs-prompt>
     <vs-prompt
     title="Email to customer"
     accept-text="Send"
     @accept="send_email"
      :active.sync="emailPrompt">
       <div class="con-exemple-prompt">
          Enter email
         <vs-input class="w-full mt-2" placeholder="john@smith.com" v-model="customer_email"/>
       </div>
     </vs-prompt>
    </div>
  </div>
</template>


<script>
import { _generate_payment_link, _send_sms, _send_email } from "@/services/Smspay";
import { _recordAnalytics } from "@/services/analytics";

export default {
  data() {
    return {
      booking_id: "",
      portal_id: "",
      payment_link: "",
      source: "",
      destination: "",
      date_time: "",
      price: "",
      current_company: this.$store.state.company.companyID,
      smsPrompt: false,
      emailPrompt: false,
      customer_telephone: "",
      customer_email: "",
      pickup_due_time: null,
      systemId : this.$store.state.AppActiveUser.systemId,
      company_name: null,
    };
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.current_company = val;
    },
  },
  methods: {
    go_generate() {
      console.log(this.systemId);

        this.payment_link = "";
        this.source = "";
        this.destination = "";
        this.date_time = "";
        this.price = "";
        this.$vs.loading();

      _generate_payment_link({
        companyId: this.current_company,
        bookingId: this.booking_id,
      })
        .then(
          (res) => {

            _recordAnalytics({
              booking_id: this.booking_id, // Use your booking ID or reference
              button_type: 'generate_link',
              system_id: this.systemId
            }).then((res)=> {});



            this.payment_link = res.data.obj.message;
            this.source = res.data.obj.pickup;
            this.destination = res.data.obj.destination;
            this.date_time = res.data.obj.date_time;
            this.pickup_due_time = res.data.obj.pickup_due_time;
            this.price = res.data.obj.price;
            this.customer_telephone = res.data.obj.customer_phone
            this.customer_email = res.data.obj.customer_email
            this.company_name = res.data.obj.company_name
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => this.$vs.loading.close());
    },

    send_sms() {
      const message = "Heres your payment link for Booking ID "+ this.booking_id + " at " + this.pickup_due_time + ". Link : "+ this.payment_link;
      let data = {
        phonenumber: this.customer_telephone,
        message:  message,
        bookingId: this.booking_id,
      }
      this.$vs.loading();
      _send_sms(data).then(res => {
          this.$vs.notify({
          text: 'SMS sent successfully',
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
        });
        },
        (error) => {
          this.handleError(error);
        }
      )
      .catch(error => {
          this.handleCatch(error);
      })
      .finally(() => this.$vs.loading.close());


    },
    send_email() {
      const message2 = this.company_name+ ": Hello Your ride from "+ this.source +" to " +this.destination+" at "+ this.pickup_due_time+ " has been booked. Booking Ref: " + this.booking_id + ". Would you like a fixed price and pay by card click the link ";
      let data = {
        email: this.customer_email,
        message:  message2,
        link: this.payment_link
      }
      this.$vs.loading();
      _send_email(data).then(res => {
        this.$vs.notify({
          text: 'Email sent successfully',
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
        });
        },
        (error) => {
          this.handleError(error);
        }
      )
      .catch(error => {
          this.handleCatch(error);
      })
      .finally(() => this.$vs.loading.close());

    },
    handleError(error) {
      if (error.response.status == 422) {
        this.$vs.notify({
          title: "validation error",
          text: "",
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      } else {
        this.$vs.notify({
          title: error.response.data.responseTitle,
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.options-alignment {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
    &>* {
    margin-right: 1.5rem;
    margin-top: 1.5rem;
  }
}
</style>
